firebird.directive('clipboard', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.children().bind('click', function (e) {
                e.stopPropagation();
                element.trigger('click');
            });

            var clipboard = new Clipboard(element[0]);

            clipboard.on('success', function (e) {
                element.tooltip('show');

                setTimeout(function () {
                    element.tooltip('hide');
                }, 3000);

                e.clearSelection();
            });
        }
    };
});
